import React from 'react'

import { Button, Icon, ArrowRight } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { arrayOf, number, shape, string } from 'prop-types'

import usePromoTracking, { LOCATION_BY_TYPE } from 'Pods/CollectionHub/Hooks/usePromoTracking'

import CollectionGallery from './CollectionGallery'

function Collection({ collection, slot = 0, collectionType = 'cg' }) {
  const { id, title, description, href, previewImages } = collection

  const collectionId = `collection-${id}`

  const { ref, handleSelect } = usePromoTracking({
    id,
    name: title,
    creative: 'row',
    slot,
    collectionType,
  })

  return (
    <article
      ref={ref}
      className="collection"
      aria-labelledby={`${collectionId}-title`}
      data-promo-id={id}
      data-promo-name={title}
      data-promo-creative="row"
      data-promo-slot={slot}
      data-promo-location={LOCATION_BY_TYPE[collectionType] || ''}
    >
      <div className="collection__info">
        <header className="collection__header">
          <h2
            id={`${collectionId}-title`}
            className="collection__title cgt-legacy-text-default cgt-legacy-text-default--semi-bold"
          >
            {title}
          </h2>
          <Button
            type="secondary"
            trailIcon={<Icon svgComponent={ArrowRight} size="small" />}
            href={href}
            size="small"
            customClass="collection__button collection__button--desktop"
            onClick={handleSelect}
          >
            Go to collection
          </Button>
        </header>
        <p className="collection__description cgt-text-medium">{description}</p>
      </div>
      <CollectionGallery
        images={previewImages}
        href={href}
        collectionTitle={title}
        onItemClick={handleSelect}
      />
      <Button
        type="secondary"
        trailIcon={<Icon svgComponent={ArrowRight} size="small" />}
        href={href}
        size="small"
        customClass="collection__button collection__button--mobile"
        onClick={handleSelect}
      >
        Go to collection
      </Button>
    </article>
  )
}

Collection.propTypes = {
  collection: shape({
    id: string.isRequired,
    title: string.isRequired,
    description: string.isRequired,
    href: string.isRequired,
    badge: string,
    previewImages: arrayOf(
      shape({
        id: string.isRequired,
        url: string.isRequired,
        alt: string.isRequired,
      })
    ).isRequired,
  }).isRequired,
  slot: number,
  collectionType: string,
}

export default Collection
